<template>

  <v-container fluid v-bind="bind_container" v-scroll="onScroll" class="mt-3" >

      <v-layout wrap row justify-center class="px-2">
        <v-flex xs12 md10 lg8>
          <v-layout wrap row justify-center class="px-2">
            <v-flex xs12 md4 lg3>
              <v-img :src="logoTrSearchEngine" height="45px" contain position="center center" style="margin-top: 10px;" />
            </v-flex>
            <v-flex xs10 md6>
              <ais-search-box submit-title="search" :autofocus="true" />
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>




      <v-layout row wrap align-space-around >
        <v-flex xs12 md12 lg3 >
          <component :is="panelNames[searchPanel][0]" />
        </v-flex>
        <v-flex xs12 md12 lg9 id="resultsTitle">
            <v-flex xs12>
              <v-container fluid v-bind="bind_container" >
                <v-layout row wrap >
                  <v-flex md12>
                    <div v-bind="bind_current_refinements">
                      <ais-current-refinements :attributeLabels="attributeLabels" />
                    </div>
                    <v-toolbar dense class="mb-2 pb-2 elevation-1 stats-toolbar" >
                      <v-layout row wrap >
                        <v-flex xs12 sm4 >
                          <v-checkbox class="checkboxSelectAll" v-show="showBookmark"
                            off-icon="bookmark_border"
                            v-model="checkbox_all"
                            on-icon="bookmark" />
                          <v-menu
                            v-model="menu"
                            :close-on-content-click="false"
                            :nudge-width="180"
                            :nudge-right="3"
                            offset-x
                          >
                            <v-btn dark small class="add_to_bookmark_btn" style="margin-left: 0px!important;"   slot="activator" color="indigo" v-show="anySelectedResult" @click="show_bookmark = !show_bookmark">
                              <v-icon>add</v-icon>Add to bookmark
                            </v-btn>
                            <v-card class="add_to_bookmark_menu">
                            <v-list>
                              <v-list-tile>
                                <v-list-tile-title>Select a bookmark</v-list-tile-title>
                              </v-list-tile>
                              <v-divider></v-divider>
                              <v-list-tile v-for="pool in poolsFiltered" :key="pool.id" class="tile_document">
                                <v-list-tile-title>
                                  <v-btn small flat @click="saveDocumentsToPool(pool.pool_id)"><v-icon>add</v-icon> <span v-text="pool.name" /></v-btn>
                                </v-list-tile-title>
                              </v-list-tile>
                              <v-list-tile class="tile_add_document" >
                                <v-list-tile-title>
                                  <v-text-field
                                    v-model="newPoolName"
                                    placeholder="New bookmark name"
                                    @keyup.enter="addPool()"
                                    :rules="[rules.required, rules.counter]"
                                    counter
                                    maxlength="20"
                                    ></v-text-field>
                                </v-list-tile-title>
                                <v-list-tile-action>
                                  <v-btn dark color="indigo" @click="addPool()">Create</v-btn>
                                </v-list-tile-action>
                              </v-list-tile>
                            </v-list>
                            </v-card>
                          </v-menu>
                          <suggestionFormPress v-if="$route.name === 'press'" style="margin-left: -8px!important;"/>
                          <suggestionFormCompanyReports v-if="$route.name === 'companyReports'" style="margin-left: -8px!important;" />
                          <suggestionFormAirportShops v-if="$route.name === 'airportShops' || $route.name === 'seAirportShops'" style="margin-left: -8px!important;" />
                          <v-btn small style="margin-left: 0px!important;"
                            slot="activator"
                            v-show="showAddLocalizationButton"
                            @click="showAddLocalizationForm(); onClickOpen('click-addnewshop')">
                            <v-icon>add</v-icon>Add new shop
                          </v-btn>
                          <create-entity v-if="$route.name === 'wiki'" style="margin-left: -8px!important;"/>
                        </v-flex>
                        <v-flex xs12 sm4  class="text-xs-center" >
                          <v-toolbar-title class="ais_stats">
                            <ais-stats></ais-stats>
                          </v-toolbar-title>
                        </v-flex>
                        <v-flex xs12 sm4 >
                          <v-toolbar-title class="ais_results_per_page_selector">
                            <ais-results-per-page-selector :options="[20, 50, 100]" inline-template >
                              <v-select
                                :class="bem()"
                                v-model="resultsPerPage"
                                :items="options"
                                label="Solo field"
                                solo
                              ></v-select>
                            </ais-results-per-page-selector>
                          </v-toolbar-title>
                        </v-flex>
                      </v-layout>
                    </v-toolbar>
                    <v-card>
                      <ais-results>
                        <template slot-scope="{ result, resultsGrouped }" >
                          <component :is="panelNames[searchPanel][1]"
                          :result="result"
                          :results-by-report-id="resultsGrouped[result.reportId]"
                          :display-show-document="displayShowDocument" />
                        </template>
                      </ais-results>
                    </v-card>
                    <v-toolbar dense class="mb-2 elevation-1 pagination-toolbar">
                      <v-layout row >
                        <v-flex xs12>
                          <v-toolbar-title>
                            <div class="text-xs-center">
                              <ais-pagination @page-change="$vuetify.goTo('#resultsTitle', {easing: 'easeInOutCubic', offset: 60})"
                              inline-template v-bind="bind_pagination_padding" >
                                <ul :class="bem()" class="v-pagination theme--light" v-show="totalResults > 0">
                                  <li :class="[bem('item', 'first'), page === 1 ? bem('item', 'disabled', false) : '']">
                                    <button href="#" @click.prevent="goToFirstPage" class="v-pagination__item" :class="[bem('link'), page === 1 ? 'v-pagination__navigation--disabled' : 'v-icon material-icons theme--light', $vuetify.breakpoint.mdAndDown ? 'navigation_button': '']">
                                      <v-icon material-icons theme--dark>first_page</v-icon>
                                    </button>
                                  </li>
                                  <li :class="[bem('item', 'previous'), page === 1 ? bem('item', 'disabled', false) : '', page === 1 ? 'v-pagination__navigation--disabled' : 'v-icon material-icons theme--light']">
                                    <button href="#" @click.prevent="goToPreviousPage" class="v-pagination__item" :class="[bem('link'), $vuetify.breakpoint.mdAndDown ? 'navigation_button': '']">
                                      <v-icon material-icons theme--dark>chevron_left</v-icon>
                                    </button>
                                  </li>
                                  <li v-for="item in pages" :key="item" :class="[bem('item'), page === item ? bem('item', 'active', false) : '']" >
                                    <button href="#" @click.prevent="goToPage(item)" :class="[bem('link'), page === item ? 'v-pagination__item v-pagination__item--active primary' : 'v-pagination__item', $vuetify.breakpoint.mdAndDown ? 'navigation_button': '']" >
                                      <slot :value="item" :active="item === page">
                                        {{ item }}
                                      </slot>
                                    </button>
                                  </li>
                                  <li :class="[bem('item', 'next'), page >= totalPages ? bem('item', 'disabled', false) : '', page >= totalPages ? 'v-pagination__navigation--disabled' : 'v-icon material-icons theme--light']">
                                    <button href="#" @click.prevent="goToNextPage" class="v-pagination__item" :class="[bem('link'), $vuetify.breakpoint.mdAndDown ? 'navigation_button': '']" >
                                      <v-icon material-icons theme--dark>chevron_right</v-icon>
                                    </button>
                                  </li>
                                  <li  :class="[bem('item', 'last'), page >= totalPages ? bem('item', 'disabled', false) : '']">
                                    <button href="#" @click.prevent="goToLastPage" class="v-pagination__item" :class="[bem('link'), page >= totalPages ? 'v-pagination__navigation--disabled' : 'v-icon material-icons theme--light', $vuetify.breakpoint.mdAndDown ? 'navigation_button': '']">
                                      <v-icon material-icons theme--dark>last_page</v-icon>
                                    </button>
                                  </li>
                                </ul>
                              </ais-pagination>
                            </div>
                          </v-toolbar-title>
                        </v-flex>
                      </v-layout>
                    </v-toolbar>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-flex>
        </v-flex>
      </v-layout>
      <v-btn color="blue darken-3" dark fixed bottom floating right fab
        style="display:none" v-bind="goToTopButtonVisible"
        @click="$vuetify.goTo(0, {
          duration: 700,
          offset: 0,
          easing: 'easeInOutCubic'
        })"
      >
        <v-icon material-icons theme--dark>keyboard_arrow_up</v-icon>
      </v-btn>
      <documentForm />
      <locationForm v-if="$route.name === 'airportShops' || $route.name === 'seAirportShops'" />
      <addShopForm v-if="$route.name === 'airportShops' || $route.name === 'seAirportShops'" />
      <addPosForm v-if="$route.name === 'airportShops' || $route.name === 'seAirportShops'" />

  </v-container>

</template>

<script>

import AisSearchBox from './AisComponents/AisSearchBox'
import AisClear from './AisComponents/AisClear'

import AisStats from './AisComponents/AisStats'
import AisResults from './AisComponents/AisResults'
import AisCurrentRefinements from './AisComponents/AisCurrentRefinements'
import SuggestionFormPress from './Press/SuggestionForm'
import SuggestionFormCompanyReports from './CompanyReports/SuggestionForm'
import SuggestionFormAirportShops from './Location/SuggestionForm'
import PressSearchPanel from './Press/Search'
import PressResultPanel from './Press/ResultPanel'
import CompanyReportsSearchPanel from './CompanyReports/Search'
import CompanyReportsResultPanel from './CompanyReports/ResultPanel'
import DocumentForm from './DocumentForm'
import LocationForm from './Location/LocationForm'
import AddShopForm from './Location/AddShopForm'
import AddPosForm from './Location/AddPosForm'
import CreateEntity from './Wiki/CreateEntity'
import PoliciesSearchPanel from './Policies/Search'
import PoliciesResultPanel from './Policies/ResultPanel'
import LocationSearchPanel from './Location/Search'
import LocationResultPanel from './Location/ResultPanel'
import WikiSearchPanel from './Wiki/Search'
import WikiResultPanel from './Wiki/ResultPanel'
import { mapMutations, mapState, mapGetters } from 'vuex'
import ADD_DOCUMENTS_TO_POOL from '@/graphql/AddDocumentsToPool.gql'
import CREATE_POOL from '@/graphql/CreatePool.gql'
import LOGGER from '@/graphql/Logger.gql'
import POOLS from '@/graphql/Pools.gql'
import USER from '@/graphql/User.gql'

import { Component } from 'vue-instantsearch'

export default {
  name: 'SearchEnginePage',
  props: ['searchPanel'],
  mixins: [Component],
  data () {
    return {
      user: false,
      logoTrSearchEngine: require('../assets/Logo TR Search Engine.png'), // eslint-disable-line no-undef
      pools: [],
      panelNames: {
        'press': [PressSearchPanel, PressResultPanel],
        'companyReports': [CompanyReportsSearchPanel, CompanyReportsResultPanel],
        'localizations': [LocationSearchPanel, LocationResultPanel],
        'wiki': [WikiSearchPanel, WikiResultPanel],
        'policies': [PoliciesSearchPanel, PoliciesResultPanel]
      },
      attributeLabels: {
        'who_union': 'Who',
        'what_union': 'What',
        'how_union': 'How',
        'company.n': 'Supplier',
        'retailBrand.n': 'Related actor',
        'product_category_union': 'Product category'
      },
      displayShowDocument: true,
      offsetTop: 0,
      offsetBottom: 0,
      show_bookmark: false,
      menu: false,
      newPoolName: '',
      rules: {
        required: value => !!value || 'Required.',
        counter: value => value.length <= 15 || 'Max 15 characters'
      },
      dictionary: {
        custom: {
          proofMessage: {
            required: () => 'Proof / Message can not be empty'
          }
        }
      }
    }
  },
  components: {
    AisSearchBox,
    AisClear,
    AisResults,
    AisStats,
    AisCurrentRefinements,
    SuggestionFormPress,
    SuggestionFormCompanyReports,
    SuggestionFormAirportShops,
    PressSearchPanel,
    PressResultPanel,
    CompanyReportsSearchPanel,
    CompanyReportsResultPanel,
    PoliciesSearchPanel,
    PoliciesResultPanel,
    LocationSearchPanel,
    LocationResultPanel,
    LocationForm,
    WikiSearchPanel,
    WikiResultPanel,
    CreateEntity,
    DocumentForm,
    AddShopForm,
    AddPosForm
  },
  created () {
    if (this.globalSearch !== '') {
      this.searchStore.query = this.globalSearch
    }
  },
  methods: {
    ...mapMutations(['addError', 'setLoginSignupForm']),
    ...mapMutations('searchEnginePage', ['setSelectAllCheckbox', 'setResultsCheckbox']),
    ...mapMutations('locationForm', ['setViewedAddShopDialog']),
    // ...mapMutations('wiki', ['setViewedCreateEntityDialog']),
    onScroll (e) {
      this.offsetTop = window.pageYOffset || document.documentElement.scrollTop
      this.offsetBottom = document.documentElement.scrollHeight - document.documentElement.clientHeight - this.offsetTop
    },
    async saveDocumentsToPool (poolId) {
      this.$apollo.mutate({
        mutation: ADD_DOCUMENTS_TO_POOL,
        variables: {
          pool_id: poolId,
          document_ids: this.getSelectedCheckbox
        },
        update: (store, { data: { poolId } }) => {
          this.$apollo.queries.pools.refetch()
        }
      }).then((data) => {
        this.menu = false
        this.setSelectAllCheckbox([false])
      }).catch((error) => {
        if (error.networkError.statusCode === 401) {
          this.$auth0.login()
        } else {
          this.addError(error)
        }
      })
    },
    async addPool () {
      if (!this.newPoolName) return false
      let data = await this.$apollo.mutate({
        mutation: CREATE_POOL,
        variables: {
          document_type: this.$route.name,
          name: this.newPoolName
        }
      }).catch((error) => {
        if (error.networkError.statusCode === 401) {
          this.$auth0.login()
        } else {
          this.addError(error)
        }
      })
      this.$apollo.mutate({
        mutation: ADD_DOCUMENTS_TO_POOL,
        variables: {
          pool_id: data.data.createPool,
          document_ids: this.getSelectedCheckbox
        },
        update: (store, { data: { poolId } }) => {
          this.$apollo.queries.pools.refetch()
        }
      }).then((data) => {
        this.menu = false
        this.setSelectAllCheckbox([false])
        this.newPoolName = ''
      }).catch((error) => {
        if (error.networkError.statusCode === 401) {
          this.$auth0.login()
        } else {
          this.addError(error)
        }
      })
    },
    showAddLocalizationForm () {
      this.setViewedAddShopDialog(true)
    },
    onClickOpen (action) {
      this.$apollo.mutate({
        mutation: LOGGER,
        variables: {
          level: 'info',
          message: JSON.stringify({
            module: this.$route.name,
            action
          })
        }
      })
    }
  },
  computed: {
    ...mapState(['globalSearch', 'authenticated']),
    ...mapState(
      'searchEnginePage', [
        'selectAllCheckbox',
        'resultsCheckbox'
      ]
    ),
    ...mapGetters('searchEnginePage', ['getSelectedCheckbox']),
    anySelectedResult () {
      let values = Object.values(this.resultsCheckbox)
      return values.some(e => e !== undefined ? e : false)
    },
    showAddLocalizationButton () {
      return this.searchPanel === 'localizations'
    },
    showBookmark () {
      return ['press', 'companyReports'].indexOf(this.searchPanel) > -1
    },
    checkbox_all: {
      set (value) {
        this.setSelectAllCheckbox([!this.selectAllCheckbox])
      },
      get () {
        return this.selectAllCheckbox
      }
    },
    bind_pagination_padding () {
      const binding = {}
      if (this.$vuetify.breakpoint.mdAndDown) binding.padding = 2
      return binding
    },
    bind_container () {
      const binding = {}
      if (this.$vuetify.breakpoint.mdAndDown) binding.style = 'padding:0px; margin-top:15px;'
      return binding
    },
    bind_current_refinements () {
      const binding = {}
      if (this.$vuetify.breakpoint.mdAndDown) binding.style = 'margin-left: 12px;'
      return binding
    },
    bind_ais_clear () {
      const binding = { "style": "padding-left: 15px" }
      if (this.$vuetify.breakpoint.mdAndDown) binding.style = 'padding-left: 20px'
      return binding
    },
    goToTopButtonVisible () {
      const binding = {}
      if (this.offsetTop > 800) binding.style = 'display:inline;'
      if (this.offsetBottom < 30 && this.$vuetify.breakpoint.mdAndDown) binding.style = 'display:inline;bottom: 60px;'
      return binding
    },
    poolsFiltered () {
      return this.pools ? this.pools.filter(p => p.document_type === this.$route.name ? p : false) : []
    }
  },
  watch: {
    '$route': function (val) {
    }
  },
  apollo: {
    pools: {
      query: POOLS,
      skip () {
        return !this.authenticated
      }
    },
    user: {
      query: USER,
      skip () {
        return !this.$auth0.isAuthenticated()
      }
    }
  }
}
</script>
<style>
.ais_stats {
  font-size: 16px;
  margin-left: 0px!important;
  padding-top: 10px;
}
.ais_results_per_page_selector .v-input {
    width: 75px;
    height: 40px;
    border: 1px solid #d8d8d8;
    float: right
}

.v-pagination__item--active a {
  color: white;
}
.v-pagination__navigation a {
  text-decoration-line: none;
}
.v-pagination__navigation {
  box-shadow: 0 3px 14px 2px rgba(0,0,0,0.12);
  margin: .3rem 5px;
}
.pagination-toolbar .v-toolbar__content {
  padding: 0px;
  margin-top:10px;
}

.stats-toolbar .v-toolbar__content {
  height: auto!important;
}
.navigation_button {
  margin: .1rem;
}

.checkboxSelectAll {
  width: 30px;
  float: left;
  padding-top: 10px!important;
  margin-left: -8px!important;
}
.checkboxSelectAll .v-input__control {
  height: 28px;
}

/* .add_to_bookmark_btn {
  position: absolute!important;
} */
/* IE 10+ */
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
   .add_to_bookmark_btn {
      position: relative!important;
    }
}
/* EDGE */
@supports (-ms-ime-align: auto) {
  .checkboxSelectAll {
    padding-top: 0px!important;
  }
}
/* Mozilla */
@-moz-document url-prefix() {
  /* .add_to_bookmark_btn {
    margin-top: 15px!important;
  } */
  /* .checkboxSelectAll {
    padding-top: 5px!important;
  } */
}

.add_to_bookmark_menu {
  border: 1px solid #aaa!important;
}
.add_to_bookmark_menu .v-list__tile__title {
  line-height: 1.5!important;
  width: 225px;
}
.add_to_bookmark_menu .tile_document .v-list__tile__title {
  height: 44px!important;
  width: 98%!important;
}
.add_to_bookmark_menu .tile_document .v-list__tile__title button {
  margin-left: -10px!important;
}
.add_to_bookmark_menu .tile_document .v-list__tile__title button .v-icon {
  margin-right: 10px;
}
.add_to_bookmark_menu .tile_add_document .v-list__tile__title {
  height: 65px!important;
  width: 60%!important;
  margin-right: 15px;
  margin-top: -10px;
}
.add_to_bookmark_menu .tile_add_document .v-input__control {
  min-height: 36px;
}
.add_to_bookmark_menu .tile_add_document .v-list__tile__action {
  align-items: normal!important
}
.add_to_bookmark_menu .tile_add_document .v-text-field__details {
  margin-top:3px;
}

.add_to_bookmark_menu .v-list__tile__title button {
  margin-bottom: 10px!important;
  width: 100%;
}
.add_to_bookmark_menu .v-list__tile__title button .v-btn__content{
  justify-content: left;
}

</style>
